function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("linearGradient", {
  x1: "40.969%",
  y1: "7.971%",
  x2: "63.36%",
  y2: "109.64%",
  id: "send-done-d"
}, React.createElement("stop", {
  stopColor: "#4D128B",
  offset: "0%"
}), React.createElement("stop", {
  stopColor: "#9C53B7",
  offset: "100%"
})), React.createElement("linearGradient", {
  x1: "-13.346%",
  y1: "75.789%",
  x2: "108.784%",
  y2: "15.594%",
  id: "send-done-e"
}, React.createElement("stop", {
  stopColor: "#FFEB4F",
  offset: "0%"
}), React.createElement("stop", {
  stopColor: "#00E300",
  offset: "100%"
})), React.createElement("path", {
  id: "a",
  d: "M0 0h686v958H0z"
}), React.createElement("path", {
  d: "M181.44 79.945l-19.57-19.453c-.547-.547-.82-1.25-.82-2.11 0-.859.273-1.562.82-2.109l4.336-4.218c.547-.625 1.23-.938 2.051-.938.82 0 1.543.313 2.168.938L183.55 65.18l28.125-28.125c.625-.625 1.348-.938 2.168-.938.82 0 1.504.313 2.05.938l4.337 4.218c.547.547.82 1.25.82 2.11 0 .86-.273 1.562-.82 2.11l-34.57 34.452c-.548.625-1.25.938-2.11.938-.86 0-1.562-.313-2.11-.938z",
  id: "send-done-g"
}), React.createElement("filter", {
  x: "-50.8%",
  y: "-65.9%",
  width: "201.7%",
  height: "236.3%",
  filterUnits: "objectBoundingBox",
  id: "send-done-f"
}, React.createElement("feOffset", {
  dy: 1,
  in: "SourceAlpha",
  result: "shadowOffsetOuter1"
}), React.createElement("feGaussianBlur", {
  stdDeviation: 10,
  in: "shadowOffsetOuter1",
  result: "shadowBlurOuter1"
}), React.createElement("feColorMatrix", {
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.193373033 0",
  in: "shadowBlurOuter1"
})), React.createElement("rect", {
  id: "send-done-c",
  x: 0,
  y: 0,
  width: 687,
  height: 1498,
  rx: 50
}));

var _ref3 =
/*#__PURE__*/
React.createElement("g", {
  transform: "translate(155 458)",
  id: "done-btn"
}, React.createElement("rect", {
  fill: "#FFF",
  opacity: 0.247,
  y: 306,
  width: 380,
  height: 80,
  rx: 40
}));

var _ref4 =
/*#__PURE__*/
React.createElement("g", {
  transform: "translate(210 538)"
}, React.createElement("g", {
  id: "done-check"
}, React.createElement("circle", {
  fill: "url(#send-done-e)",
  cx: 190,
  cy: 60,
  r: 60
}), React.createElement("g", {
  fillRule: "nonzero"
}, React.createElement("use", {
  fill: "#000",
  filter: "url(#send-done-f)",
  xlinkHref: "#send-done-g"
}), React.createElement("use", {
  fill: "#FFF",
  xlinkHref: "#send-done-g"
}))));

var SvgSendDone = function SvgSendDone(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 686 958",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, React.createElement("g", {
    mask: "url(#send-done-b)"
  }, React.createElement("path", {
    xmlns: "http://www.w3.org/2000/svg",
    d: "M63 54h17.872v41.2h-9.587V61.651H63V54zm35.352 40.864c-3.024 0-5.432-2.296-5.432-5.488 0-3.248 2.408-5.376 5.432-5.376 3.024 0 5.432 2.128 5.432 5.376 0 3.192-2.408 5.488-5.432 5.488zm85.424-15.616v7.392h-6.384v8.232h-8.848V86.64h-21.112v-6.104l18.48-24.864h9.52l-17.136 23.576h10.528v-7.336h8.568v7.336h6.384zm-57.88 15.296c-9.632 0-16.8-7.336-16.8-20.272 0-12.936 7.168-20.272 16.8-20.272 9.688 0 16.8 7.336 16.8 20.272 0 12.936-7.112 20.272-16.8 20.272zm-.184-7.344c4.536 0 7.672-3.696 7.672-12.6S130.248 62 125.712 62c-4.48 0-7.616 3.696-7.616 12.6s3.136 12.6 7.616 12.6zm112.544 4.088v3.584h-27.72v-39.2h26.88v3.584H214.68V73.2h20.272v3.528H214.68v14.56h23.576zm38.464 0v3.584H249v-39.2h26.88v3.584h-22.736V73.2h20.272v3.528h-20.272v14.56h23.576zm35.328 3.584l-12.656-17.248-12.6 17.248h-4.76l14.896-20.16-13.944-19.04h4.76l11.816 16.016 11.76-16.016h4.48L301.912 74.6l14.952 20.272h-4.816z",
    fill: "#FFF",
    fillRule: "nonzero",
    style: {
      transform: "translate(156px, 240px)"
    }
  })), _ref3, _ref4));
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgSendDone, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/send-done.639db28b.svg";
export { ForwardRef as ReactComponent };